/**
 * 原生分享功能的封装
 */

import allConf from '../config';

import { getOldParamAlias } from '../global-api/alias';

import { compareAppVersion, isFusionKit } from '../global-api/app';

export function initShare(DDBridge) {
    DDBridge.setShare = function(param) {
        let buttons = param.buttons;
        // 低版本的，<5.x alias
        if (!isFusionKit() && compareAppVersion('<', '5.0.0')) {
            for (var i in buttons) {
                buttons[i].type = allConf.api[buttons[i].type].alias;
                buttons[i].data && (buttons[i].data = getOldParamAlias(buttons[i].data));
            }
        }
        param.buttons = buttons;
        DDBridge.call('initEntrance', param, function() {});
        DDBridge.call('showEntrance', param, function() {});
    };
}



// WEBPACK FOOTER //
// ./src/pages/epower/bridge/ddbridgebeatles/global-api/share.js